// API Configuration — use for all API paths so Vercel Preview/staging hits the right backend (not the production rewrite).

function stripTrailingSlashes(url: string): string {
  return url.replace(/\/+$/, '');
}

const rawBase = process.env.REACT_APP_API_URL || 'http://localhost:4000';

/** Resolved API origin (no trailing slash). */
export const API_URL = stripTrailingSlashes(rawBase);

/** Prefix a path such as `/api/...` with the configured API origin (no trailing slash on API_URL). */
export const apiUrl = (path: string) => `${API_URL}${path}`;
